import React from 'react';
import PropTypes from 'prop-types';
import { Container, Column, Row } from '@pella/sash-framework';
import { CTA, Image } from '../../';
import { isValidArray } from '../../utilities/validations';

const ProjectsHero = ({ data }) => (
	<Container className='max-md:!p-0 md:!pl-0'>
		<Row
			className='relative'
			noGutters
		>
			<Column
				xs={12}
				md={6}
			>
				{isValidArray(data?.image) && (
					<Image
						className='pointer-events-none !block aspect-[1.75] before:absolute before:inset-x-0 before:bottom-0 before:!z-1 before:h-1/4 before:bg-gradient-to-b before:from-transparent before:to-black before:content-[""]'
						data={data.image[0]}
					/>
				)}
				{isValidArray(data?.cta) && (
					<CTA
						className='absolute bottom-3 z-2 pl-6 font-semibold text-white decoration-primary md:pl-8 xl:pl-16'
						data={data.cta[0]}
					/>
				)}
			</Column>

			<Column
				xs={12}
				md={6}
				className='flex flex-col justify-center max-md:!px-6 max-md:py-[18px] md:pl-4'
			>
				{data?.heading && (
					<h1
						className='text-h2 mb-0 pb-1.5 xl:pb-2'
						dangerouslySetInnerHTML={{ __html: data.heading }}
					/>
				)}
				{data?.description && (
					<div
						className='text-base xl:text-lg'
						dangerouslySetInnerHTML={{ __html: data.description }}
					/>
				)}
			</Column>
		</Row>
	</Container>
);

ProjectsHero.propTypes = {
	data: PropTypes.object,
};

export default ProjectsHero;
